import { Theme } from '@mui/material';
import { GeneralContentProps } from '../interfaces/generalContentProps';
import { makeStyles } from 'tss-react/mui';

export const Layout08Styles = makeStyles<GeneralContentProps>()((theme: Theme, props) => ({
  contentContainer: {
    flexDirection: props.mediaAlignment && props.mediaAlignment === 'LEFT' ? 'column-reverse' : 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: props.mediaAlignment && props.mediaAlignment === 'LEFT' ? 'row-reverse' : 'row',
    },
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '356px',
    marginTop: props.mediaAlignment === 'LEFT' ? '1rem' : '0.25rem',
    marginBottom: props.mediaAlignment === 'LEFT' ? '0.25rem' : '0rem',
    [theme.breakpoints.up('sm')]: {
      marginTop: props.mediaAlignment === 'LEFT' ? '1rem' : '1.5rem',
      marginBottom: props.mediaAlignment === 'LEFT' ? '1.5rem' : '0rem',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '1.25rem',
    },
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  titleHeading: {
    marginBottom: '0.25rem',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '1rem',
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: '0.75rem',
    },
  },
}));
